export const REQUEST_DB    = 'REQUEST_DB';
export const SELECT_CATEGORY    = 'SELECT_CATEGORY';
export const REQUEST_FAILED     = 'REQUEST_FAILED';
export const REQUEST_SUCCESSFUL = 'REQUEST_SUCCESSFUL';
export const RESET = 'RESET';



/** WEBPACK FOOTER **
 ** ./app/constants/asyncTypes.js
 **/